import React from 'react';
import { estiloDoLogo } from '../others/logoAjuste';

// Logo da empresa enquadrado no cartão (modo, tamanho, posição e cor de fundo salvos em Configurações). Ocupa
// o elemento pai inteiro (posição absoluta): o pai precisa de position: relative e overflow: hidden. Usado no
// cartão central da página inicial e na prévia do editor, para a prévia ser exatamente o que vai aparecer.
function LogoEnquadrado({ url, ajuste, alt }) {
  const { cartao, imagem } = estiloDoLogo(ajuste);
  return (
    <div style={{ position: 'absolute', inset: 0, ...cartao }}>
      <img src={url} alt={alt} draggable={false}
        style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', ...imagem }} />
    </div>
  );
}

export default LogoEnquadrado;
